import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
// import AOS from "aos";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import Breadcrumb from "./Breadcrumb";
import logoImage from "./../../assets/ayushi_log.6e5fc2d9bf89245e0c93.png";

const BlogDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(
          `https://ayushiconstruction.com/api/blogs/${slug}`,
        );
        setBlog(response.data);
        console.log(response.data);
        setLoading(false);
      } catch (err) {
        if (err.response && err.response.status === 404) {
          navigate("/blogslist"); // Redirect to blog list if not found
        } else {
          setError("Failed to load blog");
        }
        setLoading(false);
      }
    };

    fetchBlog();
    window.scrollTo(0, 0);
  }, [slug, navigate]);

  const handleFooterLink = () => {
    window.scrollTo(0, 0);
  };

  if (loading)
    return (
      <div className="container text-center my-5 mt-4">
        <h3>Loading...</h3>
      </div>
    );
  if (error)
    return (
      <div className="container text-center my-5">
        <h3>{error}</h3>
      </div>
    );
  if (!blog) return null;

  let introContent = "";
  let mainContent = "";

  const contentWithoutTags = blog.content.replace(/<[^>]*>/g, " ");
  const firstParagraphEnd = contentWithoutTags.indexOf("\n\n");

  if (firstParagraphEnd > 0) {
    introContent = contentWithoutTags.substring(0, firstParagraphEnd);
    mainContent = blog.content;
  } else {
    introContent = contentWithoutTags.substring(0, 200) + "...";
    mainContent = blog.content;
  }

  const pageTitle =
    blog.meta_title && blog.meta_title.trim()
      ? blog.meta_title.trim()
      : blog.title || "Ayushi Construction";

  const pageDesc =
    blog.meta_description && blog.meta_description.trim()
      ? blog.meta_description.trim()
      : introContent;

  const pageKeywords =
    blog.meta_keywords && blog.meta_keywords.trim()
      ? blog.meta_keywords.trim()
      : "ayushi construction, builders in jabalpur, duplex homes, real estate jabalpur";

  const canonicalUrl =
    blog.canonical_url && blog.canonical_url.trim() !== ""
      ? blog.canonical_url.trim()
      : `https://ayushiconstruction.com/blogslist/${blog.slug}`;

  const pageImage = blog.image_url
    ? `https://ayushiconstruction.com/public/uploads/${blog.image_url}`
    : "https://res.cloudinary.com/defq8e7r0/image/upload/v1740740472/Ayushi_Construction_logo_enxueh.png";

  const pageImageAlt = blog.image_alt_text || blog.title || "Ayushi Construction";

  return (
    <>
      {/* <Finalnav /> */}
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDesc} />
        <meta name="keywords" content={pageKeywords} />
        <link rel="canonical" href={canonicalUrl} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="Ayushi Construction" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDesc} />
        <meta property="og:image" content={pageImage} />
        <meta property="og:image:alt" content={pageImageAlt} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={canonicalUrl} />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDesc} />
        <meta name="twitter:image" content={pageImage} />

        {/* Schema.org BlogPosting */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "headline": blog.title,
            "description": pageDesc,
            "image": pageImage,
            "datePublished": blog.published_date,
            "dateModified": blog.updated_date || blog.published_date,
            "author": {
              "@type": "Organization",
              "name": "Ayushi Construction",
              "url": "https://ayushiconstruction.com"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Ayushi Construction",
              "logo": {
                "@type": "ImageObject",
                "url": "https://res.cloudinary.com/defq8e7r0/image/upload/v1740740472/Ayushi_Construction_logo_enxueh.png"
              }
            },
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": canonicalUrl
            }
          })}
        </script>
      </Helmet>
      <Wrapper>
        <Breadcrumb />
        <div className="container" style={{ marginTop: "4.5rem" }}>
          <div className="container">
            <h2 className="mt-5 text-center">{blog.title}</h2>
            <div
              className="underline mx-auto"
              style={{
                height: 3,
                width: "4rem",
                backgroundColor: "#000000",
                marginTop: 25,
                marginBottom: 10,
              }}
            ></div>
            <div className="text-center blog-meta">
              <span className="blog-date">
                Published: {new Date(blog.published_date).toLocaleDateString()}
              </span>
              {blog.updated_date !== blog.published_date && (
                <span className="blog-updated ms-3">
                  Updated: {new Date(blog.updated_date).toLocaleDateString()}
                </span>
              )}
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center">
                {blog.image_url ? (
                  <img
                    src={`https://ayushiconstruction.com/public/uploads/${blog.image_url}`}
                    alt={blog.image_alt_text || blog.title || "Blog Image"}
                    className="frontimg rounded m-4"
                  />
                ) : (
                  <img
                    src={logoImage}
                    alt={blog.image_alt_text || blog.title || "Default Image"}
                    className="frontimg rounded m-4"
                  />
                )}

                {/* </div> */}
              </div>
              <div className="col-lg-12 mt-3"></div>

              <div className="col-lg-12 mt-3">
                <div
                  className="blog-content"
                  dangerouslySetInnerHTML={{ __html: mainContent }}
                />
                <hr />
              </div>

              <button className="btn my-3" id="more">
                <Link
                  to="/blogslist"
                  onClick={handleFooterLink}
                  className="text-white text-decoration-none"
                >
                  ← Back to Blogs
                </Link>
              </button>
            </div>
          </div>
        </div>
      </Wrapper>
      {/* <Footer /> */}
    </>
  );
};

export default BlogDetail;

const Wrapper = styled.div`
  .row {
    justify-content: center;
  }
  button {
    background-color: #fe7604;
    border-radius: 4px;
  }
  button:hover {
    background-color: #fe7604;
  }
  .img3 {
    margin-top: 1rem;
    margin-left: -2rem;
    @media screen and (max-width: 768px) {
      margin-left: -8rem;
    }
    @media screen and (min-width: 768px) and (max-width: 1020px) {
      height: 30rem;
      margin-left: -1rem;
      margin-top: -3rem;
    }
  }

  h2 {
    font-size: 34px;
    color: #000000;
    @media screen and (max-width: 768px) {
      font-size: 1.4rem;
    }
  }

  p {
    color: #5a626d;
    text-align: justify;

    @media screen and (max-width: 768px) {
      font-size: 1rem;
    }
  }
  h5 {
    font-size: 20px;
    color: #000000; //card
    margin-top: 2rem;
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
  li {
    margin-bottom: 0.5rem;
  }
  ul {
    list-style: none;
  }
  .frontimg {
    width: 80%;
    // height: 50%;
    @media screen and (max-width: 768px) {
      height: 15rem;
      width: 80%;
      margin-top: -4rem;
    }
    @media screen and (min-width: 768px) and (max-width: 1020px) {
      height: 20rem;
      width: 80%;
      margin-top: -4rem;
    }
  }
  #more {
    width: 10rem;
    margin: 0.5rem;
    color: white;
  }

  .th {
    font-weight: bold;
  }
  .mleft {
    margin-left: 2rem;
  }

  .blog-meta {
    color: #5a626d;
    font-size: 0.9rem;
    margin-bottom: 1rem;
  }

  .blog-content {
    /* color: #5a626d;
    text-align: justify;
    border: 2px solid black;
    padding: 15px 30px 0px 30px; */

    width: 100%;
    max-width: 60rem;
    border: 2px solid black;
    padding: 2rem;
    border-radius: 1rem;
    margin: 0.5rem auto;

    /* Style for anchor tags within blog content */
    a {
      color: #0000ff;
      text-decoration: none;
      transition: color 0.2s ease;

      &:hover {
        color: #0000ff;
        text-decoration: underline;
      }
    }
  }

  h5 {
    font-size: 20px;
    color: #000000;
    margin-top: 2rem;
  }

  ul {
    list-style: none;
    padding-left: 1rem;
  }

  li {
    margin-bottom: 0.5rem;
  }
  h1 {
    font-size: 2rem;
    font-weight: 500;
  }
  h4 {
    font-size: 1.5rem;
  }
  .btndesign {
    margin-left: 32rem;
    @media screen and (max-width: 768px) {
      margin-left: 7rem;
    }
    @media screen and (min-width: 768px) and (max-width: 1020px) {
      margin-left: 18rem;
    }
  }
`;
